export const STORAGE_KEY = {
    REFRESH_TOKEN: "refreshToken",
    TOKEN: "accessToken",
    USER_ID: "userId",
    USER_TYPE: "userType",
    UUID: "uuid",
    LOGO:"logo",
    USERNAME:"userName",
    IS_FIRST_TIME:"isFirstTime",
    GAME_USER:"gameUser",
    ADS_HISTORY:"adsHistory",
    LAST_TIME:"lastTime"
};


export  const dictionary = {
header:{en:"<h1 class='text-left'>Baziigram</h1> <h2 class='text-left'>the last game you  install</h2>" , fa:"<h1 class='text-right'>بازیگرام</h1> <h2 class='text-right'>آخرین بازی که نصب میکنید</h2>"},
profileHeader:{en:"<h1 class='text-left'>Profile</h1> <h2 class='text-left'>You can view and edit your profile in this section.</h2>" , fa:"<h1 class='text-right'>پروفایل</h1> <h2  class='text-right'>شما میتوانید در این قسمت پروفایل خود را مشاهده و ویرایش کنید.</h2>"},
viewGamesBtn:{en:"View games" , fa:"مشاهده بازی ها"},
installBtn:{en:"install" , fa:"نصب میکنم"},
app:{en:"Baziigram " , fa:"اپلیکیشن بازیگرام"},
webApp:{en:"Web application" , fa:"وب اپ"},
retry:{en:"Try again" , fa:"تلاش مجدد"},
ok:{en:"Ok" , fa:"تایید"},
newGames:{en:"New games" , fa:"جدیدترین ها"},
offers:{en:"For you" , fa:"پیشنهاد برای شما"},
campaignGames:{en:"Campaign games" , fa:"بازی های کمپین"},
bestGames:{en:"Users favorite games",fa:"برترین ها از نگاه کاربران"},
allGames:{en:"Amusing games",fa:"بازی های تفننی"},
dearFriend:{en:"Dear friend" , fa:"دوست عزیز"},
generalForgetfulnessText:{en:"I can not remmember you. If you want remind me your game information, please login... " ,
 fa:"من شما رو به خاطر نمیارم،اگر میخوای یادم بیاد چند تا فیکوین داشتی، عضو چه گروهی بودی و تا چه مرحله ای جلو رفته بودی، لطفا بهم یادآوری کن"},
 loginBtn:{fa:"یادآوری" , en:"login"},
 profile:{fa:"پروفایل من" , en:"my profile"},
 login:{fa:"ورود" , en:"login"},
 prize:{fa:"جوایز" , en:"prizes"},
 news:{fa:"خبرستان" , en:"news"},
 help:{fa:"راهنما" , en:"help"},
 aboutUs:{fa:"درباره ما" , en:"About us"},
 developers:{fa:"توسعه دهندگان" , en:"Developers"},
 sendOTPbtn:{fa:"ارسال کد فعالسازی" , en:"send activation code"},
 userName:{fa:"شماره موبایل / ایمیل" , en:"mobile number/Email"},
 activationCode:{fa:"کد فعالسازی" , en:"verification code"},
name:{fa:"نام کاربری" , en:"username"},
success:{fa:"موفق" , en:"success"},
retryText:{fa:"ارتباط با سرور برقرار نشد، مجددا تلاش نمایید",en:"There is a problem, please try again."},
yes:{fa:"بله", en:"yes"},
start:{fa:"شروع", en:"Start"},
phoenixAndLifeStone:{fa:"ققنوس و سنگ زندگی", en:"Phoenix and stone of life"},
no:{fa:"خیر", en:"no"},
loginHint:{fa:"بازیکن گرامی، برای ادامه عملیات نیاز است تا هویت شما تایید شود."
          , en:"Dear player, your identity needs to be confirmed to continue the operation"},
saveBaziigram:{fa:"نجات بازیگرام",en:"rescue Baziigram"},
dailyawardTitle:{fa:"فیکوین هدیه امروز شما",en:"Phoecoins is your today Award"},
dailyAwardMessage:{fa:"شما میتوانید فیکوین های خود را تبدیل به کد تخفیف خرید محصولات مورد علاقه خود کنید",
en:"you can change your Phoecoins to discount code of purchasing your favorite products."},
dailyAwardMessage:{fa:"شما میتوانید فیکوین های خود را تبدیل به کد تخفیف خرید محصولات مورد علاقه خود کنید",
en:"you can change your Phoecoins to discount code of purchasing your favorite products."},
youAreHere:{fa:"شما اینجا هستید" , en:"You are here"},
store:{fa:"فروشگاه" , en:"store"},
offerWall:{fa:"کمک" , en:"help"},
leaderboard:{fa:"برترین ها" , en:"heroes"},
newsHeader:{fa:"آخرین اخبار سرزمین بازیگرام" + "<br/>" + "را در این قسمت مشاهده کنید" , en:"See the latest news of" + "<br/>" + "Baziigram, in this section"},
seeNews:{fa:"مشاهده",en:"Read news"},
level:{fa:"مرحله",en:"level"},
seeHeroes:{fa:"مشاهده",en:"View heroes"},
seeProfile:{fa:"مشاهده",en:"view profile"},
leaderboardHeader:{fa:"اسامی قهرمان هایی که برای شکست اهریمن" + "<br/>" + "با ققنوس همسفر شده اند" , en:"The names of the heroes who traveled" +"<br/>"+ "with the Phoenix to"  +" defeat the devil"},
buy:{fa:"خرید",en:"Buy"},
successfulPurchase:{fa:"خرید با موفقیت انجام شد",en:"The purchase is made successfully"},
storeHeader:{fa:"با پرداخت فیکوین می توانید" + "<br/>" + "آیتم های مراحل بازی را خریداری نمایید" , en:"You can buy game items" + "<br/>" + " by your Phoecoins" },
seeItems:{fa:"مشاهده",en:"View Items"},
myAssets:{fa:"دارایی های من",en:"My assets"},
developerInfo:{fa:"اطلاعات توسعه دهنده",en:"developer info"},
git:{fa:"گیت هاب",en:"Github"},
linkedin:{fa:"لینکدین",en:"LinkedIn"},
all:{fa:"همه",en:"all"},
noServerConnection:{fa:"ارتباط با سرور برقرار نشد" , en:"Could not connect to the server"},
noGroup:{fa:"تاکنون گروهی توسط کاربران ساخته نشده است.",en:"No group has been created by users yet."},
groupName:{fa:"نام گروه", en:"Group name"},
changeGroupFlag:{fa:"میتوانید پرچم گروه خود را تغییر دهید",en:"You can change your group flag"},
serverError:{fa:"عملیات با خطا مواجه شد" , en:"The operation encountered an error"},
noJoinRequest:{fa:"درخواست عضویتی برای این گروه وجود ندارد.",en:"There is no join request for this group."},
sendJoinRequest:{fa:"درخواست با موفقیت ارسال شد.",en:"Join request is sent successfully."},
leaveGroup:{fa:"با موفقیت از گروه خارج شدید.",en:"You have left successfully."},
join:{fa:"عضویت", en:"join"},
noAward:{fa:"در حال حاضر جایزه ای موجود نیست.",en:"There are currently no awards available."},
onlinePersons:{fa:"نفر آنلاین",en:"online"},
viewChats:{fa:"مشاهده",en:"View messages"},
chatHeader:{fa:"در این قسمت می توانید با" + "<br/>" + "هم گروهی های خود صحبت کنید" , en:"You can chat with your teammates"},
accept:{fa:"قبول",en:"accept"},
reject:{fa:"رد",en:"reject"},
close:{fa:"بستن",en:"close"},
LetsGo:{fa:"بزن بریم",en:"let's go"},
offerwallHeader:[{fa:"من برات پیشنهاداتی دارم که بتونی زودتر",en:"I have suggestions for you <br/>that you can buy"},
{fa:" را بخری و از مرحله ",en:""},
{fa:"",en:" and pass "},
{fa:" عبور کنی ",en:" level "}
],
goToStore:{fa:"بریم فروشگاه",en:"Go to store"},
phoecoin:{fa:"فیکوین",en:"Phoecoins"},
watchToEnd:{fa:"برای دریافت فیکوین، باید تبلیغ را تا انتها تماشا کنید",en:"You have to watch the Ad till the end to get the Phoecoin"},
AdLoadingError:{fa:"خطا در نمایش تبلیغ",en:"Failed to display rewarded ad"},
error:{fa:"خطا",en:"error"},
connecting:{fa:"در حال برقراری ارتباط",en:"connecting"},
newRequests:{fa:"درخواست جدید",en:"new request"},
newMessages:{fa:"پیام جدید",en:"new message"}
}